import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
    height: '100%',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    overflow: 'scroll',
    [theme.breakpoints.up('mobile')]: {
      display: 'flex',
      justifyContent: 'center',
    },
  },
  content: {
    padding: [theme.spacing(4), theme.spacing(3), 0],
    width: '100%',
    height: '100%',
    display: 'flex',
    flexFlow: 'column',
    [theme.breakpoints.up('mobile')]: {
      minWidth: 700,
      maxWidth: 1420,
    },
  },
  tabs: {
    borderBottom: [1, 'solid', theme.palette.colors.border],
  },
  tab: {
    marginRight: theme.spacing(3),
    '&:first-child': {
      marginLeft: theme.spacing(3),
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/LoanOfficerRealEstateAgents/useStyles.js